<template>
  <div>
     <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick" :style="tabsStyle">
      <el-tab-pane :label="$t('finance', 'personalCommission')" name="first"> <personalCommission v-if="activeName == 'first'" /> </el-tab-pane>
      <el-tab-pane :label="$t('finance', 'employeeCommission')" name="second"> <employeeCommission v-if="activeName == 'second'" /> </el-tab-pane>
      <el-tab-pane :label="$t('finance', 'withdrawalList')" name="third"> <withdrawalList v-if="activeName == 'third'" /> </el-tab-pane>
      <el-tab-pane :label="$t('finance', 'commissionSettings')" name="fourth"> <commissionSettings v-if="activeName == 'fourth'" /> </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import personalCommission from './components/personalCommission';
import employeeCommission from './components/employeeCommission';
import withdrawalList from './components/withdrawalList';
import commissionSettings from './components/commissionSettings';
import i18nMixin from "@/mixins/i18nMixin";

export default {
  name:'commissionManagement',
  mixins: [i18nMixin],
  components:{
    personalCommission,
    employeeCommission,
    withdrawalList,
    commissionSettings
  },
  computed: {
    tabWidth() {
      const currentLang = this.$store.state.currentLanguage;
      if (currentLang === 'en') {
        return '160px'; // 英文使用160px
      } else {
        return '100px'; // 中文使用100px
      }
    },
    tabsStyle() {
      return {
        '--tab-item-width': this.tabWidth,
        '--tab-active-bar-width': this.tabWidth,
      };
    }
  },
  data(){
    return{
      activeName:'first'
    }
  },
  created() {
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听，添加安全检查
    if (this.$root) {
      this.$root.$off('language-changed');
    }
  },
  methods:{
    handleClick(tab){
      const { name } = tab;
      this.activeName = name;
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  /deep/ .el-tabs__item  {
    width: var(--tab-item-width) !important;
  }

  /deep/ .el-tabs__active-bar {
   width: var(--tab-active-bar-width) !important;
  }
}
</style>
